import { dom } from "@fortawesome/fontawesome-svg-core";
import { openReferenceDialog } from "./reference-dialog";
import { initScroll } from "./utils";

export const initProfileReferencesSlider = () => {
  const slider: HTMLDivElement | null = document.querySelector(".profile-references-slider");

  if (!slider) {
    return;
  }

  // The whole reference card opens the dialog, so it works for every reference
  // even when there is no truncated "read more" affordance.
  slider.addEventListener("click", (event) => {
    const target = event.target as Element;

    // Load-more link fetches the next page (it also lives inside a .card).
    if (target.closest(".load-more-item")) {
      event.preventDefault();
      loadMore(slider);
      return;
    }

    // Real links (referencer profile, owner edit) navigate.
    if (target.closest("a")) {
      return;
    }

    const card = target.closest(".open-reference-dialog") as HTMLElement | null;
    if (card && slider.contains(card)) {
      openReferenceDialog(card);
    }
  });

  // Keyboard support for the card acting as a button.
  slider.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }
    const card = event.target as HTMLElement;
    if (card.classList?.contains("open-reference-dialog")) {
      event.preventDefault();
      openReferenceDialog(card);
    }
  });

  function loadMore(slider: HTMLDivElement) {
    const sliderWrapper = slider.querySelector(".slider-wrapper") as HTMLDivElement | null;
    if (!sliderWrapper) {
      return;
    }
    const itemsWrapper = sliderWrapper.querySelector(".slider-items") as HTMLDivElement;

    const userId = sliderWrapper.getAttribute("data-user-id");
    const offset = sliderWrapper.getAttribute("data-pagination-offset") as string;
    const limit = sliderWrapper.getAttribute("data-pagination-limit") as string;

    const overlayWrapper = slider.closest(".loader-overlay-wrapper") as HTMLDivElement;
    const loaderOverlay = overlayWrapper.querySelector(
      ".references-block-loader",
    ) as HTMLDivElement;
    const apiError = overlayWrapper.querySelector(".api-error") as HTMLDivElement;

    loaderOverlay.classList.remove("d-none");

    const nextOffset = parseInt(offset, 10) + parseInt(limit, 10);

    fetch(`/website-api/user/${userId}/references/?limit=${limit}&offset=${nextOffset}`, {
      credentials: "same-origin",
      method: "get",
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const newWidget = parser.parseFromString(html, "text/html");
        const widgetBlock = newWidget.querySelector(".widget-block") as HTMLDivElement;
        const items = widgetBlock.querySelectorAll(".slider-items .slider-item");

        //remove load more item
        itemsWrapper.querySelector(".load-more-item")?.remove();
        sliderWrapper.setAttribute("data-pagination-offset", nextOffset.toString());

        items.forEach((item) => {
          itemsWrapper.appendChild(item);
        });

        dom.i2svg();

        initScroll(slider);

        loaderOverlay.classList.add("d-none");
      })
      .catch((_error) => {
        loaderOverlay.classList.add("d-none");
        apiError.classList.remove("d-none");
      });
  }
};
